import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const getRest = (props)=>{
    const rest = swcHelpers.objectWithoutProperties(props, [
        "className",
        "index",
        "number",
        "label",
        "status",
        "hideLabel",
        "onClick",
        "disabled"
    ]);
    return rest;
};
const getSharedProps = (props)=>{
    const { className , disabled , status ='open'  } = props;
    return swcHelpers.objectSpread({
        className: classnames('step', `step--${status}`, className),
        'aria-disabled': disabled,
        'aria-current': status === 'active' ? 'step' : undefined
    }, disabled ? {
        disabled
    } : {});
};
const Step = (props)=>{
    const { onClick , disabled , label , index , hideLabel , number , status ='open'  } = props;
    const onClickHandler = React.useCallback(()=>{
        if (onClick && !disabled) {
            onClick(label, index);
        }
    }, [
        label,
        index,
        disabled,
        onClick
    ]);
    // Only render this component as a button when there is a click handler
    if (!!onClick) {
        return /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, getRest(props), getSharedProps(props), {
            onClick: onClickHandler
        }), /*#__PURE__*/ React.createElement(StepContent, {
            number: number,
            hideLabel: hideLabel,
            label: label,
            status: status
        }));
    } else {
        return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, getRest(props), getSharedProps(props), {
            role: "group"
        }), /*#__PURE__*/ React.createElement(StepContent, {
            number: number,
            hideLabel: hideLabel,
            label: label,
            status: status
        }));
    }
};
const StepContent = ({ number , hideLabel , label , status  })=>{
    const { getLabel  } = useIntl();
    const accessibleStepLabel = getLabel('common.step');
    const accessibleStatusLabel = status === 'active' && getLabel('common.active') || status === 'skip' && getLabel('common.skipped') || status === 'done' && getLabel('common.done');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "step__number",
        "aria-hidden": true
    }, number), /*#__PURE__*/ React.createElement(Icon, {
        className: "step__checkmark",
        name: "checkmark"
    }), accessibleStepLabel && /*#__PURE__*/ React.createElement("span", {
        className: "step__visually-hidden"
    }, `${accessibleStepLabel} ${number}`), /*#__PURE__*/ React.createElement("span", {
        className: classnames('step__label', {
            'step__label--hide-label': hideLabel
        })
    }, label), accessibleStatusLabel && /*#__PURE__*/ React.createElement("span", {
        className: "step__visually-hidden"
    }, ". ", accessibleStatusLabel));
};

export { Step as default };
//# sourceMappingURL=Step.js.map
